import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const postCreateTasksFromAssignments = async (projectId, timelineId) => {
  const apiPath = `timelines/project/${projectId}/timeline/${timelineId}/create-tasks-from-assignments`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: {},
  });
  const response = await axios(signedRequest);

  return response.data;
};
